import { environment } from 'environments/environment';

export class FrontendApi {
    static readonly oauth = environment.apiUrl + '/oauth';
    static readonly audit = environment.apiUrl + '/audit';
}
